import {createStore, withProps} from '@ngneat/elf';
import {withEntities, withUIEntities} from '@ngneat/elf-entities';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {
  ExecutionLine,
  ExecutionLinesFilters,
  ExecutionLineState,
  ExecutionLineTotalDto,
  ExecutionLineUI
} from '@store/invoices/executionLines/executionLine.model';
import {withPagination} from '@ngneat/elf-pagination';
import {TableConfig} from '@constants/table.constants';
import {GridSortItem} from '@mui/x-data-grid-pro';
import {TablePagination} from '@store/common/pagination.model';
import {InvoicingSource} from '@store/common/organisation.model';
import {readyForInvoicingKey} from '@screens/admin/invoices/executions/Executions.tab';

export interface ExecutionLinesState {
  filters: ExecutionLinesFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
  total: ExecutionLineTotalDto;
  readyForInvoicing: any[];
}

export const executionLineStore = createStore(
  {name: 'executionLines'},
  withProps<ExecutionLinesState>({
    filters: {
      search: '',
      tableFilters: ExecutionLinesFilters.initTableFilters(),
      excludeTableFilters: ExecutionLinesFilters.initExcludeTableFilters(),
      filterInvoicingRequired: true,
      filterReadyForInvoicing: false,
      invoicingSource: InvoicingSource.MOS,
      state: ExecutionLineState.FA_OR_RA_REQUIRED,
      ids: [],
    },
    sort: {
      field: 'execution.executedAt',
      sort: 'asc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
    total: {
      totalPrice: 0,
      totalCost: 0,
      totalCostVatIncluded: 0,
      totalPriceVatIncluded: 0,
      isFromSameSupplierUnit: false,
      paymentTerm: undefined,
    },
    readyForInvoicing: JSON.parse(localStorage.getItem(readyForInvoicingKey) || '[]')
  }),
  withEntities<ExecutionLine>(),
  withUIEntities<ExecutionLineUI>(),
  withPagination(),
  withRequestsStatus(),
);
